"use client";
import React, { createContext, useCallback, useContext, useEffect, useState } from "react";

export type PartnerIdContext = {
  setPartnerId: (id: string) => void;
  partnerId: string | null;
  setIsDisplay: (display: boolean) => void;
  isDisplay: boolean;
};

const partnerIdContext = createContext<PartnerIdContext | undefined>(undefined);

export const PartnerIdContextProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [partnerId, setPartnerIdState] = useState<string | null>(null);
  const [isDisplay, setIsDisplay] = useState(true);
  useEffect(() => {
    const partnerId = localStorage.getItem("partnerId");
    setPartnerIdState(partnerId);
  }, [setPartnerIdState])

  const setPartnerId = useCallback(
    (id: string) => {
      localStorage.setItem("partnerId", id);  // TODO need to check later
      setPartnerIdState((prevId) => (prevId !== id ? id : prevId));
    },
    []
  );

  return (
    <partnerIdContext.Provider value={{ setPartnerId, partnerId, setIsDisplay, isDisplay }}>
      {children}
    </partnerIdContext.Provider>
  );
};

export const usePartnerIdContext = () => {
  const context = useContext(partnerIdContext);
  if (!context) {
    throw new Error(
      "usePartnerIdContext must be used within a PartnerIdContextProvider"
    );
  }
  return context;
};
